// extracted by mini-css-extract-plugin
export default {"container":"Guide_container__KMJBj","warnBlock":"Guide_warnBlock__oO5Xs","warnImg":"Guide_warnImg__WfKjz","guideInfo":"Guide_guideInfo__LVeLN"};